





import React, {useState,useEffect} from 'react';

import "./CoursesWhole.css"
import NavBar from '../../Components/NavBar/NavBar';
import CMSNews from '../../Components/CMSNews/CMSNews';
import FeaturedCoursesWhole from '../../Components/FeaturedCoursesWhole/FeaturedCoursesWhole';
import OurStrength from '../../Components/OurStrength/OurStrength';
import Faqs from '../../Components/FAQs/FAQs';
import Footer from '../../Components/Footer/Footer';
import axios from 'axios'
import ScrollToTop from '../../Components/ScrollTop/ScroolTop';




function CoursesWhole() { 

        const [courses, setCourses] = useState();

        useEffect(()=>{
                async function getCourses (){ 
                     
                   try{      
         
                     const response =   await axios.get(process.env.REACT_APP_BASEURL+'/courses/')
         
         
                     console.log("am in useffect")
         
                     // if (courses){
         
                       if(response && response?.status == 200){ 
         
                        //    console.log("Courses",response.data)
                           setCourses(response?.data);
         
                       } else{
                         setCourses(coursesType)
                        //  console.log("courses",courses)
                       }
                      
                     // }
         
                   }catch(e){
                     setCourses(coursesType)
                         //console.log("courses",courses)
                         // console.log("catch error",e)
                   }
                      
         
                }
                
                 //  Async response = axios.get('http://localhost:8800/Books')
         
                 getCourses()
                  
         
             },[])      

             const coursesType = [
                {
                    "CourseName " : "Monitoring and Evaluation",
                    "CourseCode " : "DS110",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "4",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "2500",
                    "Price" : "1750",
                    "Image" :"",
                    "Description" :"Now than ever before organizations are more likely to receive funding if they can",
                    "DescriptionTwo" :"E-Views offers a wide range of features for data manipulation, statistics and econometric analysis, as well as for forecasting, simulations and analytical presentations of data. E-Views is used to estimate and run the different models for estimation and prediction. The course introduces a participant to the various techniques, and means of how to upload data and interpret results. The course aims to familiarize one with background knowledge on data analysis using E-Views. The course is designed "
                },
                {
                    "CourseName " : "Microsoft Project Management (for tracking)",
                    "CourseCode " : "ADM200",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "2",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "2000",
                    "Price" : "1750",
                    "Image" :"",
                    "DescriptionTwo" :"The course will allow the participants to master the basics of excel. The course is designed for beginners who want to learn how to create and edit spreadsheets, perform basic calculations using formulas and functions, sort, filter analyze and visualize detailed data. ",
                    "Description" :"Microsoft Project management computer application/learning "
                },
                {
                    "CourseName " : "Introduction to Microsoft Excel",
                    "CourseCode " : "ADM100",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "2",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "1500",
                    "Price" : "1750",
                    "Image" :"",
                    "Description" :"The course will allow the participants to master the basics of excel. The course is designed for beginners who want to learn how to create and edit spreadsheets, perform basic calculations using formulas and functions, sort, filter analyze and visualize detailed data. ",
                    "DescriptionTwo" :"Microsoft Project management computer application/learning "
                },
                {
                    "CourseName " : "Intro. NVivo for Qualitative Data Analysis",
                    "CourseCode " : "DS100",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "1",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "1000",
                    "Price" : "1750",
                    "Image" :"",
                    "Description" :"Qualitative researchers now have the option to apply technology tools in their approach for data management and data analysis to ease the complexity of the research process. NVivo is one such powerful software for the qualitative analysis of text, audio, video, survey and social media data.",
                    "DescriptionTwo" :"Qualitative researchers now have the option to apply technology tools in their approach for data management and data analysis to ease the complexity of the research process. NVivo is one such powerful software for the qualitative analysis of text, audio, video, survey and social media data. The course is going to be a five-day course with an aim of providing a comprehensive overview of NVivo and an opportunity for participants to analyse qualitative data for their own projects. The course will p "
                },
                {
                    "CourseName " : "Digital Marketing",
                    "CourseCode " : "MKT100",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "3",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "2000",
                    "Price" : "1750",
                    "Image" :"",
                    "Description" :"In this hands-on and interactive course, you will dive into the core components of digital marketing, gaining practical skills and knowledge essential for today's business environment. From understanding the fundamentals of online advertising to harnessing the power of social media and analytics, this course covers it all.",
                    "DescriptionTwo" :"In this hands-on and interactive course, you will dive into the core components of digital marketing, gaining practical skills and knowledge essential for today's business environment. From understanding the fundamentals of online advertising to harnessing the power of social media and analytics, this course covers it all."
                },
                {
                    "CourseName " : "Data Analysis in E-Views",
                    "CourseCode " : "MKT110",
                    "Category " : "Digital Marketing Strategy",
                    "CategoryTwo " : "Digital Marketing Strategy",
                    "CategoryThree " : "Digital Marketing Strategy",
                    "Lecturer" : "Professor Jere Mulenga",
                    "Pretext" : "Develop digital marketing strategies that reach and retain customers",
                    "Duration_Weeks" : "2",
                    "HourlyDuration" : "6 - 7",
                    "EnrollDeadline" : "January 14",
                    "Cost" : "1500",
                    "Price" : "1750",
                    "Image" :"",
                    "Description" :"E-Views offers a wide range of features for data manipulation, statistics and econometric analysis, as well as for forecasting, simulations and analytical presentations of data.",
                    "DescriptionTwo" :"Qualitative researchers now have the option to apply technology tools in"
                },
           
            ]
 

  return <>

        <div className='CoursesWholeContainer'> 
        

            <NavBar/>

            <ScrollToTop/>

            <div className='CoursesWholeforewording'>       

                    <div className='HeadingFilter'>
                            <div className='preword'>
                                    <p>UNILUS | Online</p>
                            </div>
                            <div className='FilterDropDown'>
                                    <button>Online Based certificate courses</button>
                            </div>
                    </div>
                    <div className='MoreWording'> 
                        <div className='moreWordingContainer'>  

                            <h1>Online Business Certificate Courses</h1>  

                            <p>
                                    Gain applicable skills, build new business capabilities, and tap into the confidence you need to improve your organization and advance your career.
                            </p>

                        </div>
                         

                    </div>

            </div>

            {/* END OF FOREWORD */}
            <CMSNews/>
            <FeaturedCoursesWhole Heading={"Our courses"}/>
            {/* <FeaturedCoursesWhole Heading={"Entrepreneurship & Innovation"}/>
            <FeaturedCoursesWhole Heading={"Digital Marketing"} /> */}
            <OurStrength/>
            <Faqs/>
            <Footer/>
            

            
        </div>
       
    
  </>
  
  ;
}

export default CoursesWhole;